import serverCall from "../../serverCall";

const createCategory = async (name, preview, data) => {
  const response = await serverCall.post(
    `/category/admin/add-category?categoryName=${name}&previewEnable=${preview}`,
    data
  );
  return response;
};

const updateCategory = async (data) => {
  const response = await serverCall.post(`/category/admin/edit`, data);
  return response;
};

const GetAllCategory = async (pageNumber, pageSize, search) => {
  let response = "";
  if (pageNumber === 0 && pageSize === 0) {
    response = await serverCall.get(
      `/category/admin/all-category?pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
  } else {
    response = await serverCall.get(
      `/category/admin/all-category?pageNumber=${pageNumber}&pageSize=${pageSize}&searchText=${search}`
    );
  }
  return response;
};

const GetAllImages = async (
  pageNumber,
  pageSize,
  category,
  search,
  imageType,
  sortBy,
  sortType,
  collectionName
) => {
  let response = "";
  if (imageType !== "All") {
    response = await serverCall.get(
      `/images/admin/search?categoryName=${category}&imageType=${imageType}&pageNumber=${pageNumber}&pageSize=${pageSize}&searchTags=${search}&sortBy=${sortBy}&sortType=${sortType}&collectionName=${collectionName}`
    );
  } else {
    response = await serverCall.get(
      `/images/admin/search?categoryName=${category}&pageNumber=${pageNumber}&pageSize=${pageSize}&searchTags=${search}&sortBy=${sortBy}&sortType=${sortType}&collectionName=${collectionName}`
    );
  }
  return response;
};

const DeleteCategory = async (id) => {
  const response = await serverCall.delete(`/category/admin/${id}`);
  return response;
};
const DeleteImagesList = async (id) => {
  const response = await serverCall.delete(`/images/admin/${id}`);
  return response;
};

const CategoryService = {
  createCategory,
  GetAllCategory,
  DeleteCategory,
  updateCategory,
  GetAllImages,
  DeleteImagesList,
};

export default CategoryService;
